// api.js

export const getServerURL = () => {
  switch (process.env.REACT_APP_NODE_ENV) {
    case 'production':
      return `${process.env.REACT_APP_BASE_URL_PRODUCTION}/admin/api/v1/`;
    case 'test':
      return `${process.env.REACT_APP_BASE_URL_TEST}/admin/api/v1/`;
    default:
      return `${process.env.REACT_APP_BASE_URL}/admin/api/v1/`;
  }
};
